import EventEmitter from 'events';
import TypedEventEmitter from 'typed-emitter';
import { FlowpageModel } from '@/components/layout/FlowpageModel';
import ActionsModel from '@/models/actions/ActionsModel';
import { RedirectEvent } from '@/services/url';
import { FormSubmitEvent } from '@/events/formSubmit';
import { SectionModelType } from '@/typings/types/types';
import { FormSubmitResponseEvent } from '@/events/formSubmitResponse';

// Available events that can be listened to.
export type Events = {
  flowPageChange: (from?: FlowpageModel, to?: FlowpageModel) => void;
  sectionReady: (container: Element, model: SectionModelType) => void;
  sectionBeforeEnterAnimation: (model: SectionModelType) => void;
  sectionBeforeLeaveAnimation: (model: SectionModelType) => void;
  sectionBeforeEnter: (model: SectionModelType) => void;
  sectionBeforeLeave: (model: SectionModelType) => void;
  sectionAfterLeave: (model: SectionModelType) => void;
  invalidAction: (action: ActionsModel) => void;
  resizeFrame: () => void;
  popoverShow: (popoverId: number) => void;
  popoverHide: () => void;
  redirect: (event: RedirectEvent) => void;
  formSubmit: (event: FormSubmitEvent) => void;
  formSubmitResponse: (event: FormSubmitResponseEvent) => void;
};

/**
 * Construct our event emitter. This uses the already existing EventEmitter in NodeJS / Browser & with
 * typing (as TypedEventEmitter) we can then add correct type safety to it at no overhead.
 *
 * @author Dannie Hansen <dannie@leadfamly.com>
 */
export const events = new EventEmitter() as TypedEventEmitter<Events>;
